// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__zgp24","label":"Textarea_label__zFzw3","textarea":"Textarea_textarea__2DCy1","textareaError":"Textarea_textareaError__CUnn4"};